import "./App.css";
import Login from "./Components/Login";
import Nvabar from "./Components/Nvabar";
import Blogp from "./Components/Blogp";
import NewPost from "./Components/NewPost";
import { Route, Routes } from "react-router-dom";
import HomePage from "./Components/HomePage";
import Footer from "./Components/Footer";
import Read from "./Components/Read";
import Lund from "./Components/Scroll";
import Scroll from "./Components/Scroll";

function App() {
  return (
    <div className="App">
      <Scroll />
      <Routes>
        <Route exact path="/" element={<Login />}></Route>
        <Route exact path="/home" element={<HomePage />}></Route>
        <Route exact path="/home/:type" element={<Blogp />}></Route>
        <Route exact path="/new" element={<NewPost />}></Route>
        <Route exact path="/read/:id" element={<Read />}></Route>
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
